import { FileText, ReceiptText, RefreshCw } from "lucide-react";
import type { ReactNode } from "react";
import "./accounting-widgets.css";

export function AccountingWidgetHeading({ children, kind = "documents" }: { children: ReactNode; kind?: "documents" | "payments" | "sync" }) {
  const Icon = kind === "payments" ? ReceiptText : kind === "sync" ? RefreshCw : FileText;
  return <div className="accounting-widget-header"><Icon size={15} strokeWidth={2} aria-hidden="true" /><h2>{children}</h2></div>;
}
